import { Instagram } from "lucide-react";
import { CONTACT } from "@/data/teamData";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#050B14] text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid md:grid-cols-3 gap-8 items-start">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img
              src="/30sff-logo.png"
              alt="The 30s FF"
              className="w-12 h-12 object-contain"
            />
            <div className="font-display text-2xl tracking-wider">THE 30s FF</div>
          </div>
          <p className="text-white/60 text-sm max-w-sm">
            Tim fun football resmi. Dibangun atas persaudaraan, dirayakan tiap akhir pekan.
          </p>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.3em] text-white/40 mb-3">JELAJAH</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#beranda" className="hover:text-[#E63946] transition-colors">Beranda</a></li>
            <li><a href="/#pertandingan" className="hover:text-[#E63946] transition-colors">Pertandingan</a></li>
            <li><a href="/#skuad" className="hover:text-[#E63946] transition-colors">Skuad</a></li>
            <li><a href="/#galeri" className="hover:text-[#E63946] transition-colors">Galeri</a></li>
            <li><a href="/#kontak" className="hover:text-[#E63946] transition-colors">Kontak</a></li>
          </ul>
        </div>

        <div>
          <div className="text-[10px] tracking-[0.3em] text-white/40 mb-3">IKUTI KAMI</div>
          <div className="flex gap-3">
            <a
              href={CONTACT.instagramUrl}
              data-testid="social-instagram"
              target="_blank"
              rel="noreferrer noopener"
              className="w-10 h-10 border border-white/20 hover:bg-[#E63946] hover:border-[#E63946] flex items-center justify-center transition-colors"
            >
              <Instagram size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <span>© 2026 The 30s FF — All rights reserved.</span>
          <span>BUILT WITH PASSION ON THE PITCH</span>
        </div>
      </div>
    </footer>
  );
}
